import { useQuery } from "@apollo/client";
import { GET_ALL_DYNAMIC_PROCESSES } from "../../api/get-all-dynamic-processes";
import Table from "@/shared/data-display/table";
import { FC } from "react";
import { useTranslations } from "use-intl";
import { SaveDynamicProcessModelInModalProps } from "@/modules/admin-panel/dynamic-processes/features/save-dynamic-process-model/save-dynamic-process-model-in-modal";
import Button from "@/shared/form/button";
import Tag from "@/shared/data-display/tag";

export function DynamicProcessesList({
  DeleteButton,
  EditEntityBasedProcess,
  EditDynamicProcess,
}: {
  DeleteButton: FC<{ id: string }>;
  EditEntityBasedProcess: FC<{ id: string; name: string }>;
  EditDynamicProcess: FC<SaveDynamicProcessModelInModalProps>;
}) {
  const t = useTranslations("DynamicProcessesList");

  const { data, loading, previousData } = useQuery(GET_ALL_DYNAMIC_PROCESSES);

  return (
    <Table
      dataSource={
        data?.getAllDynamicProcesses ??
        previousData?.getAllDynamicProcesses ??
        []
      }
      rowKey={(record) => record.id}
      loading={loading}
      columns={[
        {
          key: "name",
          title: t("Name"),
          dataIndex: "name",
          width: "60%",
          ellipsis: { showTitle: true },
          render: (_, record) => {
            switch (record.__typename) {
              case "DynamicEntityBasedModelDefinitionDto":
                return (
                  <EditEntityBasedProcess
                    id={record.id}
                    name={record.name.value as string}
                  />
                );
              case "DynamicModelDefinitionDto":
                return (
                  <EditDynamicProcess
                    processId={record.id}
                    Trigger={({ onClick }) => (
                      <Button onClick={onClick} type="link">
                        {record.name.value}
                      </Button>
                    )}
                  />
                );
              default:
                throw new Error("Unknown process type");
            }
          },
        },
        {
          key: "active",
          title: t("Active"),
          dataIndex: "active",
          align: "center",
          width: "20%",
          render: (_, { active }) => (
            <Tag color={active ? "success" : "default"}>
              {active ? t("Yes") : t("No")}
            </Tag>
          ),
        },
        {
          key: "delete",
          title: t("Delete"),
          align: "center",
          width: "20%",
          render: (_, { id }) => <DeleteButton id={id} />,
        },
      ]}
    />
  );
}
